import React, { useEffect, useState } from "react";
import {
  Drawer,
  Button,
  Box,
  Typography,
  IconButton,
  Divider,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IOSSwitch } from "./IOSSwitch";
import { useTranslation } from "react-i18next";
import { driverDrawer } from "../style";
import { useTripDocument } from "../../../context/TripDocumentContext";
import {
  VectorDeclarationFetchMetaData,
  VehicleDocumentFetchMetaData,
} from "../../tripDetails/docPayloads";
import { useBusinessProfile } from "../../../utils/hooks/useBusinessProfile";

import { formatDateGGMMAAAA, formatDateTime } from "../../../utils/DateUtils";
import { useWindowSize } from "../../../utils/hooks/useWindowSize";

interface SidebarViewVehicleProps {
  open: boolean;
  onClose: () => void;
  onAddVehicle: (
    newVehicle: any,
    isEdit: boolean,
    originalLicensePlate: string
  ) => void;
  selectedVehicle?: any;
  fleetInfo: {
    vehicleTypes: Record<string, string[]>;
    envClasses: string[];
    fuels: string[];
  };
  onEdit: () => void;
}

const SidebarViewVehicle: React.FC<SidebarViewVehicleProps> = ({
  open,
  onClose,
  onAddVehicle,
  selectedVehicle,
  fleetInfo,
  onEdit
}) => {
  //CONTEXT
  const { businessProfile } = useBusinessProfile();
  const {  fetchLatestPODDoc } = useTripDocument();
  const { t } = useTranslation();
  const { getDocumentDetails, isDocumentLoading } = useTripDocument();

  //FILTER DATA
 

  

  //DATA INITIALIZATION
  const [vehicleData, setVehicleData] = useState({
    licensePlate: selectedVehicle?.licensePlate || "",
    mainCategory: selectedVehicle?.mainCategory || "",
    category: selectedVehicle?.category || "",
    firstRegistrationDate: selectedVehicle?.firstRegistrationDate || "",
    vehicleDocument: selectedVehicle?.vehicleDocument || null,
    environmentClass: selectedVehicle?.environmentClass || null,
    fuelType: selectedVehicle?.fuelType || null,
    emissionsData: selectedVehicle?.emissionsData || null,
    emissionsDataUOM: selectedVehicle?.emissionsDataUOM || "",
    vectorDeclaration: selectedVehicle?.vectorDeclaration || null,
    status: selectedVehicle?.status ?? "ACTIVE",
    lastTraceabilityCheck: selectedVehicle?.lastTraceabilityCheck || "",
    loadCapacity: selectedVehicle?.loadCapacity || null,
    loadCapacityUOM: selectedVehicle?.loadCapacityUOM || "q",
  });
  const [addVehicleLoader, setAddVehicleLoader] = useState<boolean>(false);
  const [files, setFiles] = useState<{ [key: string]: File | null }>({
    vehicleDocument: null,
    vectorDeclaration: null,
  });


  const [vehicleDocument, setVehicleDocument] = useState<any>(null);
  const [vectorDeclaration, setVectorDeclaration] = useState<any>(null);
const [originalLicensePlate, setOriginalLicensePlate] = useState(
    selectedVehicle?.licensePlate || ""
  );
  //GENERIC FUNCTIONS
 

  const handleSwitchChange = () => {
    setVehicleData((prev) => ({
      ...prev,
      status: prev.status === "ACTIVE" ? "CANCELLED" : "ACTIVE", // Alterna tra "ACTIVE" e "CANCELLED"
    }));
  };

  //DOCUMENTS MANAGEMENTS


 

  const fetchVehicleDocuments = async () => {
    try {
      const dynamicPayload = {
        ...VehicleDocumentFetchMetaData,
        searchFilterDtoList:
          VehicleDocumentFetchMetaData.searchFilterDtoList.map((filter) => ({
            ...filter,
            fields: [
              ...filter.fields.filter(
                (field) =>
                  ![
                    "TESTO200_111",
                    "TESTO426_3",
                    "TESTO248_131",
                    "TABLE130_74",
                  ].includes(field.name)
              ),
              {
                operator: 1,
                valore1: null,
                multiple: selectedVehicle.licensePlate, //mettere qui la targa
                name: "TESTO200_111",
                externalId: "TARGA",
                description: "TARGA",
                className: "FieldBaseForSearchStringDto",
                isAdditional: true,
                visible: true,
              },
              {
                operator: 0,
                valore1: null,
                multiple: businessProfile.accountcode, //mettere qui il account id CE
                name: "TESTO426_3",
                externalId: "SUPPLIER_CODE",
                description: "Codice Anagrafica ERP",
                className: "FieldBaseForSearchStringDto",
                isAdditional: true,
                visible: true,
              },
              {
                operator: 0,
                multiple: businessProfile.legacycodes[0].legacycode, //legacy code
                name: "TESTO248_131",
                externalId: "SUPPLIER_EXTERNAL_CODE_STR",
                description: "Codice Anagrafica TMS (String)",
                className: "FieldBaseForSearchStringDto",
                isAdditional: true,
                visible: true,
              },
              {
                operator: 0,
                multiple: businessProfile.name,
                name: "TABLE130_74",
                externalId: "SUPPLIER_COMPANY_NAME",
                description: "Denominazione Fornitore",
                className: "FieldBaseForSearchStringDto",
                isAdditional: true,
                visible: true,
              },
            ],
          })),
      };

      const response = await fetchLatestPODDoc(dynamicPayload);
      if (!response || !Array.isArray(response)) {
        console.log("La risposta API non è valida.");

        return;
      }
      // Filtra solo i documenti con CREATION_DATE non null e valida la data
const validDocs = response.filter(doc => doc.CREATION_DATE !== null);

// Se non ci sono documenti validi, interrompi il flusso
if (validDocs.length === 0) {
  console.log("Nessun documento valido trovato.");
  return;
}

// Trova il documento con la CREATION_DATE più recente
const latestDocument = validDocs.reduce((latest, doc) => {
  return new Date(doc.CREATION_DATE!) > new Date(latest.CREATION_DATE!) ? doc : latest;
}, validDocs[0]); // Inizializza con il primo documento valido

      setVehicleDocument([latestDocument]);
    } catch (err: any) {
      console.log(err.message || "Errore durante il recupero dei dati.");
    }
  };

  const fetchVectorDeclaration = async () => {
    try {
      const dynamicPayload = {
        ...VectorDeclarationFetchMetaData,
        searchFilterDtoList:
          VectorDeclarationFetchMetaData.searchFilterDtoList.map((filter) => ({
            ...filter,
            fields: [
              ...filter.fields.filter(
                (field) =>
                  ![
                    "TESTO200_111",
                    "TESTO426_3",
                    "TESTO248_131",
                    "TABLE130_74",
                  ].includes(field.name)
              ),
              {
                operator: 1,
                valore1: null,
                multiple: selectedVehicle.licensePlate, //mettere qui la targa
                name: "TESTO200_111",
                externalId: "TARGA",
                description: "TARGA",
                className: "FieldBaseForSearchStringDto",
                isAdditional: true,
                visible: true,
              },
              {
                operator: 0,
                valore1: null,
                multiple: businessProfile.accountcode, //mettere qui il account id CE
                name: "TESTO426_3",
                externalId: "SUPPLIER_CODE",
                description: "Codice Anagrafica ERP",
                className: "FieldBaseForSearchStringDto",
                isAdditional: true,
                visible: true,
              },
              {
                operator: 0,
                multiple: businessProfile.legacycodes[0].legacycode, //legacy code
                name: "TESTO248_131",
                externalId: "SUPPLIER_EXTERNAL_CODE_STR",
                description: "Codice Anagrafica TMS (String)",
                className: "FieldBaseForSearchStringDto",
                isAdditional: true,
                visible: true,
              },
              {
                operator: 0,
                multiple: businessProfile.name,
                name: "TABLE130_74",
                externalId: "SUPPLIER_COMPANY_NAME",
                description: "Denominazione Fornitore",
                className: "FieldBaseForSearchStringDto",
                isAdditional: true,
                visible: true,
              },
            ],
          })),
      };

      const response = await fetchLatestPODDoc(dynamicPayload);
      if (!response || !Array.isArray(response)) {
        console.log("La risposta API non è valida.");
        return;
      }
      
      // Filtra i documenti con CREATION_DATE non null
      const validDocs = response.filter(doc => doc.CREATION_DATE !== null);
      
      // Se non ci sono documenti validi, interrompi il flusso
      if (validDocs.length === 0) {
        console.log("Nessun documento valido trovato.");
        return;
      }
      
      // Trova il documento con la CREATION_DATE più recente
      const latestDocument = validDocs.reduce((latest, doc) => {
        return new Date(doc.CREATION_DATE!) > new Date(latest.CREATION_DATE!) ? doc : latest;
      }, validDocs[0]); // Inizializza con il primo documento valido
      
      // Imposta solo il documento più recente
      setVectorDeclaration([latestDocument]);
    } catch (err: any) {
      console.log(err.message || "Errore durante il recupero dei dati.");
    }
  };

  const handleOpenFilePreview = async (
    documentId: string,
    fileFormat: string
  ) => {
    try {
      // Mappa delle estensioni ai tipi MIME
      const mimeTypes: Record<string, string> = {
        pdf: "application/pdf",
        png: "image/png",
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
      };

      // Determina il tipo MIME in base al formato, con fallback
      const contentType =
        mimeTypes[fileFormat.toLowerCase()] || "application/octet-stream";

      // Recupera i dettagli del documento come ArrayBuffer
      const documentDetails = await getDocumentDetails(documentId);

      // Creazione del Blob con l'ArrayBuffer
      const fileBlob = new Blob([documentDetails], { type: contentType });

      // Creazione dell'URL e apertura in una nuova finestra
      const url = URL.createObjectURL(fileBlob);
      window.open(url, "_blank");
    } catch (error) {
      console.error(
        "Errore durante il recupero o la visualizzazione del documento:",
        error
      );
    }
  };

  useEffect(() => {
    console.log("selectedVehicle",selectedVehicle)
  }, [selectedVehicle])
  useEffect(() => {}, [isDocumentLoading]);
  //USE EFFECTS
  useEffect(() => {
    if (selectedVehicle) {
      setVehicleData({
        licensePlate: selectedVehicle.licensePlate || "",
        mainCategory: selectedVehicle.mainCategory || "",
        category: selectedVehicle.category || "",
        firstRegistrationDate: selectedVehicle.firstRegistrationDate || "",
        vehicleDocument: selectedVehicle.vehicleDocument || null,
        environmentClass: selectedVehicle.environmentClass || null,
        fuelType: selectedVehicle.fuelType || null,
        emissionsData: selectedVehicle.emissionsData || null,
        emissionsDataUOM: selectedVehicle?.emissionsDataUOM || "g CO2/km",
        vectorDeclaration: selectedVehicle.vectorDeclaration || null,
        status: selectedVehicle.status ?? "ACTIVE",
        lastTraceabilityCheck: selectedVehicle?.lastTraceabilityCheck || "",
        loadCapacity: selectedVehicle?.loadCapacity || null,
        loadCapacityUOM: selectedVehicle?.loadCapacityUOM || "q",
      });
      setOriginalLicensePlate(selectedVehicle?.licensePlate || "");
      setFiles({
        vehicleDocument: selectedVehicle.vehicleDocument || null,
        vectorDeclaration: selectedVehicle.vectorDeclaration || null,
      });
    } else {
      // Resetta i dati se si sta aggiungendo un nuovo veicolo
      setVehicleData({
        licensePlate: "",
        mainCategory: "",
        category: "",
        firstRegistrationDate: "",
        vehicleDocument: null,
        environmentClass: null,
        fuelType: null,
        emissionsData: null,
        emissionsDataUOM: "g CO2/km",
        vectorDeclaration: null,
        status: "ACTIVE",
        lastTraceabilityCheck: "",
        loadCapacity: null,
        loadCapacityUOM: "q",
      });

      setFiles({
        vehicleDocument: null,
        vectorDeclaration: null,
      });
  
    
    }
  }, [selectedVehicle, open]);

  useEffect(() => {
    if (!open) {
      setVehicleDocument(null);
      setVectorDeclaration(null);
    } else {
      fetchVehicleDocuments();
      fetchVectorDeclaration();
    }
  }, [open]);

    
    const windowWidth = useWindowSize();
    const isMobile = windowWidth < 700;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      elevation={5}
      sx={{zIndex:999}}
      slotProps={{
      
        backdrop: {
          sx: { backgroundColor: "transparent", },
        },
      }}
    >
     <Box sx={{...driverDrawer.wrapper,width:isMobile? "100vw": 520,}}>
         <Box sx={{...driverDrawer.headerWrapper,padding:isMobile? "24px 8px": "32px 24px",}}>
                 <Typography sx={driverDrawer.headerTitle}>
            {selectedVehicle && selectedVehicle.licensePlate
              && t("common.sidebars.addVehicle.vehicle")
             }
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon sx={{ color: "#333333" }} />
          </IconButton>
        </Box>
        <Divider />
       <Box sx={{...driverDrawer.headerSubtitleWrapper,padding:isMobile? "8px" : "16px 24px",}}>
          <Typography sx={driverDrawer.headerSubtitle}>
            {t("common.sidebars.addVehicle.paragraph")}
          </Typography>
           <Box sx={{...driverDrawer.plateCategoryWrapper,flexDirection:isMobile? 'column': "row",rowGap:isMobile? "8px":0}}>
            {/**Vehicle Plate */}
            <Box sx={driverDrawer.generalBox}>
              <Typography sx={driverDrawer.mainText}>
                {t("common.sidebars.addVehicle.vehiclePlate")}
              </Typography>
              <Typography>{vehicleData.licensePlate}</Typography>
            
            </Box>

            {/**Fleet Type */}
            <Box sx={driverDrawer.generalBox}>
              <Typography sx={driverDrawer.mainText}>
                {t("common.sidebars.addVehicle.categoryType")}
              </Typography>
              <Typography>{t(`screens.fleetAndRoute.vehicles.${vehicleData.mainCategory}`)}</Typography>
            
            </Box>
          </Box>

          {/**Category & RegistrationDate*/}
          <Box sx={{...driverDrawer.plateCategoryWrapper,flexDirection:isMobile? 'column': "row",rowGap:isMobile? "8px":0}}>
            <Box sx={driverDrawer.generalBox}>
              <Typography sx={driverDrawer.mainText}>
                {t("common.sidebars.addVehicle.fleetType")}
              </Typography>
              <Typography>{vehicleData.category === "INCOMPLETE" ? "-" : t(`screens.fleetAndRoute.vehicles.${vehicleData.category}`)}</Typography>
            
            </Box>
         

            <Box sx={driverDrawer.generalBox}>
              <Typography sx={driverDrawer.mainText}>
                {t("common.sidebars.addVehicle.registrationDate")}
              </Typography>
              <Typography>
                {vehicleData.firstRegistrationDate && formatDateGGMMAAAA(vehicleData.firstRegistrationDate) !== 'Invalid Date' 
                  ? formatDateGGMMAAAA(vehicleData.firstRegistrationDate) 
                  : "-"}
              </Typography>
           
            </Box>
          </Box>

          {/**Vehicle Document */}
          <Box sx={driverDrawer.generalBox}>
            <Typography sx={driverDrawer.mainText}>
              {t("common.sidebars.addVehicle.vehicleDocument")}
            </Typography>
            {isDocumentLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
                <CircularProgress size={24} sx={{ color: "#CF0A2C" }} />
              </Box>
            ) : (
              <>
                {!vehicleData.vehicleDocument &&
                  vehicleDocument &&
                  vehicleDocument.map((doc: any, index: any) => {
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "14px",
                            textDecoration: "underline",
                            color: "#CF0A2C",
                            cursor:'pointer'
                          }}
                          onClick={() =>
                            handleOpenFilePreview(
                              String(doc?.DOCNUMBER || ""),
                              String(doc?.FORMATO || "")
                            )
                          }
                          key={index}
                        >
                          {doc.ORIGINALE}
                        </Typography>
                       
                      </Box>
                    );
                  })}
                {vehicleData.vehicleDocument && (
                  <Box sx={driverDrawer.documentBox}>
                    <a
                      href={
                        typeof vehicleData.vehicleDocument === "string"
                          ? vehicleData.vehicleDocument
                          : URL.createObjectURL(vehicleData.vehicleDocument)
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                      style={driverDrawer.uploadBox}
                    >
                      {typeof vehicleData.vehicleDocument === "string"
                        ? vehicleData.vehicleDocument.split("/").pop() // Estrai il nome file dall'URL
                        : vehicleData.vehicleDocument.name}{" "}
                      {/* Usa il nome se è un File */}
                    </a>

                    
                  </Box>
                )}
                {!vehicleData.vehicleDocument && !vehicleDocument && (
                  <Typography>-</Typography>
                )}
               
              </>
            )}
          </Box>
          {/**Load Capacity */}
          {vehicleData.mainCategory !== "Trailer" &&
            vehicleData.category !== "Standard Truck" &&
            vehicleData.category !== "Three axles truck" &&
            vehicleData.category !== "Mega Truck" && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: "16px",
                }}
              >
                <Box sx={driverDrawer.generalBox}>
                  <Typography sx={driverDrawer.mainText}>
                    {t("common.sidebars.addVehicle.loadCapacity")}
                  </Typography>
                  <Typography>{vehicleData.loadCapacity? (vehicleData.loadCapacity + " q"):"-"}</Typography>
                  
                </Box>
              </Box>
            )}
          <Divider />
          {/**Sustenibility Data */}
          {vehicleData.mainCategory !== "Trailer" && (
            <>
              <Typography
                sx={{ fontSize: "18px", fontWeight: "700", color: "#333333" }}
              >
                {t("common.sidebars.addVehicle.sustainabilityData")}
              </Typography>
               <Box sx={{...driverDrawer.plateCategoryWrapper,flexDirection:isMobile? 'column': "row",rowGap:isMobile? "8px":0}}>
                <Box sx={driverDrawer.generalBox}>
                  <Typography sx={driverDrawer.mainText}>
                    {t("common.sidebars.addVehicle.environmentalClassEuro")}
                  </Typography>
                  <Typography>{vehicleData.environmentClass? vehicleData.environmentClass:"-"}</Typography>
               
                </Box>

                <Box sx={driverDrawer.generalBox}>
                  <Typography sx={driverDrawer.mainText}>
                    {t("common.sidebars.addVehicle.fuelType")}
                  </Typography>
                  <Typography>
                    {vehicleData.fuelType 
                      ? t(`screens.fleetAndRoute.fuelType.${vehicleData.fuelType}`) 
                      : "-"}
                  </Typography>
               
                </Box>
              </Box>

              <Box sx={driverDrawer.generalBox}>
                <Typography sx={driverDrawer.mainText}>
                  {t("common.sidebars.addVehicle.emissionData")}
                </Typography>
                <Typography>{vehicleData.emissionsData?(vehicleData.emissionsData + vehicleData.emissionsDataUOM):"-"}</Typography>
               
              </Box>

              <Box sx={driverDrawer.generalBox}>
                <Typography sx={driverDrawer.mainText}>
                  {t("common.sidebars.addVehicle.vectoDeclaration")}
                </Typography>
                {isDocumentLoading ? (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", my: 2 }}
                  >
                    <CircularProgress size={24} sx={{ color: "#CF0A2C" }} />
                  </Box>
                ) : (
                  <>
                    {!vehicleData.vectorDeclaration &&
                      vectorDeclaration &&
                      vectorDeclaration.map((doc: any, index: any) => {
                        return (
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "14px",
                                textDecoration: "underline",
                                color: "#CF0A2C",
                                cursor:'pointer'
                              }}
                              onClick={() =>
                                handleOpenFilePreview(
                                  String(doc?.DOCNUMBER || ""),
                                  String(doc?.FORMATO || "")
                                )
                              }
                              key={index}
                            >
                              {doc.ORIGINALE}
                            </Typography>
                         
                          </Box>
                        );
                      })}

                    {vehicleData.vectorDeclaration && (
                      <Box sx={driverDrawer.documentBox}>
                        <a
                          href={
                            typeof vehicleData.vectorDeclaration === "string"
                              ? vehicleData.vectorDeclaration
                              : URL.createObjectURL(
                                  vehicleData.vectorDeclaration
                                )
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          style={driverDrawer.uploadBox}
                        >
                          {typeof vehicleData.vectorDeclaration === "string"
                            ? vehicleData.vectorDeclaration.split("/").pop() // Estrai il nome file dall'URL
                            : vehicleData.vectorDeclaration.name}{" "}
                          {/* Usa il nome se è un File */}
                        </a>

                      </Box>
                    )}
                    {!vehicleData.vectorDeclaration && !vectorDeclaration && (
                      <Typography>-</Typography>
                    )}
                  </>
                )}
              </Box>
            </>
          )}

          {/**Vehicle Status */}
          
            <Box sx={driverDrawer.statusBox}>
              <Typography sx={driverDrawer.mainText}>
                {t("common.sidebars.addVehicle.vehicleStatus")}:
              </Typography>
              <IOSSwitch
                checked={vehicleData.status === "ACTIVE" }
                onChange={handleSwitchChange}
                disabled={true}
              />
            </Box>
        </Box>
        <Divider  />
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            zIndex: 200,
            height: "93px",
          }}
        >
          <Button
            variant="contained"
            fullWidth
            onClick={onEdit}
              sx={{...driverDrawer.button,  maxWidth:isMobile? "96%": "300px", right:isMobile? 8: "24px", }}
            disabled={addVehicleLoader}
          >
            {addVehicleLoader ? (
              <CircularProgress size={24} sx={{ color: "#ffffff" }} />
            ) : vehicleData ? (
              t("common.sidebars.addVehicle.modify")
            ) : (
              t("common.sidebars.saveButtonText")
            )}
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SidebarViewVehicle;
